import { completeDepartureTask } from "@services/departureServiceApi";
import { useMutation } from "@tanstack/react-query";
import { runTransaction } from "@telemetry/runTransaction";

const getCompleteDepartureAction = (status?: string): string => {
  if (status?.includes("APPROVED")) return "approve_departure_request";
  if (status?.includes("REJECTED")) return "reject_departure_request";
  return "complete_departure_task";
};

export const useCompleteDepartureTask = ({
  handleSuccess,
  handleError,
}: {
  handleSuccess: () => void;
  handleError: (error: any) => void;
}) => {
  const completeTaskMutation = useMutation({
    mutationFn: (variables: Parameters<typeof completeDepartureTask>[0]) =>
      runTransaction(
        {
          module: "vessel_call",
          screen: "DepartureStatus",
          action: getCompleteDepartureAction(variables.params?.status),
          entityType: "departure_request",
        },
        (transactionId) =>
          completeDepartureTask({ ...variables, ...(transactionId ? { transactionId } : {}) }),
      ),
    onSuccess: () => {
      handleSuccess();
    },
    onError: (error) => {
      handleError(error);
    },
  });

  const completeTask = async ({
    taskId,
    params,
  }: {
    taskId: string;
    params: {
      status: string;
      requestDepartureClearance?: boolean | null;
      internalNotes?: string;
      internalAttachmentsName?: string;
      internalAttachmentsUrl?: string;
      externalNotes?: string;
      rejectionReason?: string;
      rejectionAttachmentsName?: string;
      rejectionAttachmentsUrl?: string;
      noDispute?: string;
      noDisputeName?: string;
      noDisputeUrl?: string;
    };
  }) => {
    completeTaskMutation.mutate({
      taskId,
      params,
    });
  };

  return {
    completeTask,
  };
};
